import React, { useState } from 'react'
import style from './cli.module.sass'
import TerminalLogo from '../../assets/svg/terminal.svg'

import { ReactComponent as WindowsLogo } from '../../assets/svg/windows.svg'
import { ReactComponent as LinuxLogo } from '../../assets/svg/linux.svg'
import { ReactComponent as MacLogo } from '../../assets/svg/mac.svg'
import { ReactComponent as CaretDownLogo } from '../../assets/svg/drop-2.svg'

import { Dropdown, Menu } from 'antd'

const A8StudioOSVersions: any = {
    mac: [{
        version: 'Mac (64-Bit)',
        link: 'https://storage.googleapis.com/asia.a8flowapps.autonom8.com/studio/cli/a8s-v1.0.0-f675455.pkg'
    }],
    win: [{
        version: 'Windows (32-Bit)',
        link: 'https://storage.googleapis.com/asia.a8flowapps.autonom8.com/studio/cli/a8s-v1.0.0-2960a35-x86.exe'
    }, {
        version: 'Windows (64-Bit)',
        link: 'https://storage.googleapis.com/asia.a8flowapps.autonom8.com/studio/cli/a8s-v1.0.0-2960a35-x64.exe'
    }],
    linux: [{
        version: 'Linux (64-Bit)',
        link: 'https://storage.googleapis.com/asia.a8flowapps.autonom8.com/studio/cli/a8s_1.0.0.2960a35-1_amd64.deb'
    }, {
        version: 'Linux ARM',
        link: 'https://storage.googleapis.com/asia.a8flowapps.autonom8.com/studio/cli/a8s_1.0.0.2960a35-1_armel.deb'
    }]
}

const A8FlowOSVersions: any = {
    mac: [{
        version: 'Mac (64-Bit)',
        link: 'https://storage.googleapis.com/asia.a8flowapps.autonom8.com/studio/cli/flow-cli/a8flow-v0.0.13-d489aea-x64.pkg'
    }, {
        version: 'Mac ARM',
        link: 'https://storage.googleapis.com/asia.a8flowapps.autonom8.com/studio/cli/flow-cli/a8flow-v0.0.13-d489aea-arm64.pkg'
    }],
    win: [{
        version: 'Windows (32-Bit)',
        link: 'https://storage.googleapis.com/asia.a8flowapps.autonom8.com/studio/cli/flow-cli/a8flow-v0.0.13-x86.exe'
    }, {
        version: 'Windows (64-Bit)',
        link: 'https://storage.googleapis.com/asia.a8flowapps.autonom8.com/studio/cli/flow-cli/a8flow-v0.0.13-x64.exe'
    }],
    linux: [{
        version: 'Linux (64-Bit)',
        link: 'https://storage.googleapis.com/asia.a8flowapps.autonom8.com/studio/cli/flow-cli/a8flow_0.0.13-1_amd64.deb'
    }, {
        version: 'Linux ARM',
        link: 'https://storage.googleapis.com/asia.a8flowapps.autonom8.com/studio/cli/flow-cli/a8flow_0.0.13-1_armel.deb'
    }]
}
const menu = (os: string,OSVersions:any) => (
    <Menu onClick={(e) => console.log(e)}>
      {/* <Menu.Item key="1" >
        Windows (32-Bit)
      </Menu.Item>
      <Menu.Item key="2" >
        Windows (64-Bit)
      </Menu.Item>
      <Menu.Item key="3" >
        3rd menu item
      </Menu.Item> */}
      {
          OSVersions[os].map((item: any, index: number) => {
            return (
                <Menu.Item key={index}>
                    <a href={item.link}>{item.version}</a>
                </Menu.Item>
            )
          })
      }
    </Menu>
  );


const getMenu=(os: string,selectedTab:string)=>{
    let OsVersions=selectedTab==="a8Studio" ? A8StudioOSVersions:A8FlowOSVersions; 
    return menu(os,OsVersions)
}

export const CLI = () => {
  const [selectedTab,setSelectedTab]=useState("a8Studio")
    return (
        <div className={style.container}>
            <div className={style.titleContainer}>
                <img src={TerminalLogo} style={{height:32}} alt="terminal"/>
                <div className={style.title}>Download CLI</div>
            </div>
            <div className={style.cliTab}>
                <div className={selectedTab === "a8Studio" ? style.selectedTabStyle : style.unSelectedTabStyle} onClick={() => setSelectedTab("a8Studio")}>Uniphore</div>
                <div className={selectedTab==="a8Flow" ? style.selectedTabStyle :style.unSelectedTabStyle} onClick={()=>setSelectedTab("a8Flow")}>A8 Flow</div>
            </div>
            
            <div className={style.cards}>
            <div className={style.card}>
                    <MacLogo/>
                    <div className={style.cardTitle}>Mac</div>
                    <div className={style.cardSubTitle}>OS X El Capitan & Above</div>
                    <Dropdown overlay={getMenu('mac',selectedTab)} trigger={['click']}>
                        <div className={style.download}>
                            <span>Download</span>
                            <CaretDownLogo/>
                        </div>
                    </Dropdown>
                </div>
                <div className={style.card}>
                    <WindowsLogo/>
                    <div className={style.cardTitle}>Windows</div>
                    <div className={style.cardSubTitle}>64 bit & 32 bit</div>
                    <Dropdown overlay={getMenu('win',selectedTab)} trigger={['click']}>
                        <div className={style.download}>
                            <span>Download</span>
                            <CaretDownLogo/>
                        </div>
                    </Dropdown>
                </div>
                <div className={style.card}>
                    <LinuxLogo/>
                    <div className={style.cardTitle}>Linux</div>
                    <div className={style.cardSubTitle}>64 bit & 32 bit</div>
                    <Dropdown overlay={getMenu('linux',selectedTab)} trigger={['click']}>
                        <div className={style.download}>
                            <span>Download</span>
                            <CaretDownLogo/>
                        </div>
                    </Dropdown>
                </div>
            </div>
            <div className={style.breaker}>Installation</div>
            <div className={style.instructionContainer}>
                <div className={style.instructionBlock}>
                    <div className={style.instructionTitle}>Download and install the executable corresponding to your operating system. Once installed, run the below command in terminal to get started</div>
                    <div className={style.instructionCode}>
                        <div>{selectedTab==="a8Studio" ? "a8s ":"a8flow "}--help</div>
                    </div>
                </div>
            </div>
        </div>
    )
}